import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { PaymentsService } from 'src/app/_services/payment.serice';
import { OrderLoyaltyService } from 'src/app/_services/order-loyalty.service';


import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class TabitOrderProcessService {

	constructor(
		private app: AppService,
		public entityService: EntityService,
		public orderUtils: OrderItemsUtilsService,
		public generalUtils: GeneralUtilsService,
		public paymentService: PaymentsService,
		public loyaltyService: OrderLoyaltyService,
		public dialog: MatDialog,
	) {
	}

	async processPayment(_storage: any, args: any): Promise<any> {
		let parsedOrder: any, resultOrder: any, handoffOrder: any;

		parsedOrder = this.getPreparedOrder_forserver(_storage);

		try {
			resultOrder = await this.entityService.post(`/online-shopper/orders`, parsedOrder, { 'ros-organization': _storage.siteId });

			resultOrder.organization = _storage.siteId;
		} catch (err) {
			throw err;
		}

		let ptp: any, wasSuccessPayment: boolean, wasFailurePayment: boolean;
		if (args.ccinfo) {
			ptp = _.cloneDeep(args.ccinfo);
			if (!ptp.amount) ptp.amount = parsedOrder.balanceDue + args.gratuityAmount;
			ptp.customerDetails = parsedOrder.orderer;
			ptp.tip = args.gratuityAmount;
			ptp.addPaymentToWallet = args.updatePaymentInfo;
			try {
				await this.processSinglePayment(_storage, ptp, resultOrder);
				wasSuccessPayment = true;
			} catch (err) {
				throw err;
			}
		}

		let cards = _storage.giftCards?.cards;
		if (cards && cards.length) {
			for (let card of cards) {
				try {
					let ptp = _.cloneDeep(card);
					ptp.customerDetails = parsedOrder.orderer;
					ptp.paymentMethod = 'giftCard';
					await this.processSinglePayment(_storage, ptp, resultOrder);
					wasSuccessPayment = true;
				} catch (err) {
					if (!wasSuccessPayment) {throw err;}
					wasFailurePayment = true;
				}
			}
		}

		let handoffData = { status: 'ready' };
		// if (anyPaymentError) handoffData.status = 'attendanceRequired';

		try {
			handoffOrder = await this.entityService.post(`/online-shopper/orders/${resultOrder._id}/handoff`, handoffData, { 'ros-organization': _storage.siteId });
			this.app.logTemplate("Quick order created", {}, "Quick order created", resultOrder);
			return handoffOrder.order;
		} catch (err) {
			throw err;
		}

	}

	async processSinglePayment(_storage: any, paymentInfo: any, resultOrder: any) {
		let parsedPayment: any;
		let that = this;

		const releaseOrder = paymentInfo.releaseOrder;
		parsedPayment = this.generalUtils.getPreparedPayment(paymentInfo);
		return that.paymentService.processNotCashPayment(_storage, resultOrder, parsedPayment, releaseOrder, []).then(res => {
			return res;
		}).catch(err => {
			throw (err);
		});
	}

	//------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------->

	getBasketAdditions(_storage) {
		if (!this.app.regionArgs.hasTaxesAndFees) return Promise.resolve();
		let payload = this.getPreparedOrder_forserver(_storage, { inventory: {}, isVirtual: true });
		return this.entityService.post(`/online-shopper/orders?virtual=true`, payload, { 'ros-organization': _storage.siteId }).then(order => {
			_storage.order.taxAndFees = {
				tax: _.get(order, 'totals.totalExcludedTax', 0) / 100,
				fees: _.get(order, 'totals.totalFees', 0) / 100,
				//orderData: _.pick(order, ['tax', 'taxes', 'fees', 'orderedItems', 'orderedOffers', 'courses', 'orderedDiscounts', 'rewards', 'orderedPromotions'])
			}
		}).catch(err => {
			throw (err);
		});
	}
	clearBasketAdditions(_storage) {
		_.unset(_storage, 'order.taxAndFees');
	}

	//------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------->


	ordersThatPayCashWithIntent = ['TA'];
	sentToKitchenStates = ['fired', 'prepared'];
	orderRewardsTypeMap = {
		amount: "AmountOffOrder",
		percent: "PercentOffOrder"
	}

	getPreparedOrder_forserver(_storage, options?) {
		let that = this;
		let order = _storage.order;
		options = options || { inventory: {} };
		let missingItems = {}, wasMissingInInventory;

		const phone = localStorage.getItem('c_phone') || this.app.user?.mainPhone?.pstn || '';
		const name = localStorage.getItem('c_name') || this.app.user?.name || '';

		let ret: any = {
			_id: _storage.orderId,
			organization: _storage.siteId,
			orderType: 'OTC',
			serviceType: _storage.service == 'takeaway' ? 'takeaway' : 'seated',
			//orderTags: [name, phone],
			balanceDue: order.grandTotalForOrder,
			balance: Math.round(order.grandTotalForOrder * 100),
			deliveryInfo: {
				version: this.app.version,
			},
			onlineSource: { name: "At Table" },
			orderedOffers: [],
			orderedDiscounts: [],
			orderer: {
				name: name,
				phone: phone
			}
		}
		if (_storage.tableNumber) {
			ret.table = `${_storage.tableNumber}`;
			ret.deliveryInfo.notes = `${this.app.translate('OAT.table_number')} ${_storage.tableNumber}`;
		}

		_storage.basket.forEach(offer => { prepareOffer(offer) });
		prepareExtraOffers();
		getPreparedOrderPromotion();

		if (wasMissingInInventory) throw ({
			type: "inventory",
			items: missingItems
		});

		if (!options.isVirtual) {
			let taxOrderData = _.get(_storage, 'order.taxAndFees.orderData');
			if (taxOrderData) {
				this.loyaltyService.prepareRosOrder(ret, _storage, true);
				_.assignIn(ret, taxOrderData);
			} else {
				this.loyaltyService.prepareRosOrder(ret, _storage);
			}
		} else {
			this.loyaltyService.prepareRosOrder(ret, _storage);
		}
		return ret;


		//start basket
		function prepareOffer(offer) {
			let q = offer.quantity || 1;
			for (let i = 0; i < q; i++) {
				var parsedOffer: any = {
					//"_id": that.orderUtils.getObjectId(),
					"amount": Math.round(offer.total * 100),
					"menu": offer.menu,
					"price": offer.openPrice ? 0 : Math.round(offer.price * 100),
					"offer": offer.offer,
					"name": offer.realName || offer.name,
					"upsellType": offer.upsaleType,
					"orderedItems": []
				}

				// main offer item
				if (offer._item) {
					var pitem = prepareBasketOfferItem(offer._item, offer._item.total);
					if (pitem) {
						if (offer.isWeight) {
							pitem.uom = offer.uom;
							pitem.units = offer.baseUnits;
						}
						if (offer.openPrice) {
							pitem.amount = pitem.price = parsedOffer.amount;
						}
						//ret.orderedItems.push(pitem);
						parsedOffer.orderedItems.push(pitem);
					}
				}
				// basket items
				_.each(offer.selectionSummary, function (selectionGroup) {
					_.each(selectionGroup.items, function (item) {
						let count = item.count || 1
						for (let i = 0; i < count; i++) {
							var pitem = prepareBasketOfferItem(item._item, item.price, selectionGroup);
							if (pitem) {
								//ret.orderedItems.push(pitem)
								parsedOffer.orderedItems.push(pitem);
							}
						}
					});
				});
				ret.orderedOffers.push(_.cloneDeep(parsedOffer));
			}


			function prepareBasketOfferItem(item, itemPrice, group?) {
				isInInventory(item._id, item.name);

				if (!itemPrice) itemPrice = 0;
				var parsedItem: any = {
					//"_id": that.orderUtils.getObjectId(),
					"category": item.category && item.category._id,
					"item": item._id,
					"name": item.realName || item.name,
					"price": Math.round(itemPrice * 100),
					//"tags": item.tags || []
				}
				//if (complexDiners) parsedItem.diner = offer.diner;

				if (item.notes) {
					parsedItem.note = item.notes;
				}
				if (group) {
					parsedItem.itemGroup = item.itemGroup;
					parsedItem.itemGroupName = group.name;
				} else {
					parsedItem.offer = offer.offer;
					parsedItem.menu = offer.menu;
				}
				//if (note) parsedItem.note = note;
				var itemAmount = parsedItem.price || 0;
				var modifiers = [];
				var removedModifiers = [];

				_.each(item.modifierGroups, function (group) {
					if (group.singleSelection) {
						var mod: any = _.find(group.modifiers, { '_selected': true });
						if (mod) {
							modifiers.push(prepareBasketModifier(mod, group, false, true));
							if (!mod._isDefault) {
								var defMod = _.find(group.modifiers, { '_isDefault': true });
								if (defMod) removedModifiers.push(prepareBasketModifier(defMod, group, false, false));
							}
						}
					} else {
						var isGroupCheckbox = group.modifierBehavior == "checkbox";
						_.each(group.modifiers, function (mod) {
							if (mod.formationUnit) {
								let modCount = mod.count || 1;
								for (var i = 0; i < modCount; i++) {
									if (mod.price) itemAmount = itemAmount + Math.round(mod.price * 100);
									modifiers.push(prepareBasketModifier(mod, group, true, true));
								}
							} else if (mod.defaultFormationUnit) {
								removedModifiers.push(prepareBasketModifier(mod, group, false, false));
							}
						});
					}
				});
				parsedItem.selectedModifiers = modifiers;
				parsedItem.removedModifiers = removedModifiers;
				parsedItem.amount = Math.round(itemAmount);
				return parsedItem;
			}
		}

		//start extra offers
		function prepareExtraOffers() {
			_.each(_storage.selectedExtraOffers, (newOffer) => {
				prepareBasketExtraOffer(newOffer);
			});
			_.each(_storage.selectedExtraOffersGroups, (newGroup) => {
				if (newGroup.count) {
					_.each(newGroup.offers, (newOffer) => {
						if (newOffer.count) {
							prepareBasketExtraOffer(newOffer);
						}
					});
				}
			});
			_.each(_storage.catalog.extraQuestions, (question) => {
				if (question.active) {
					if (!ret.deliveryInfo.declerations) ret.deliveryInfo.declerations = [];
					ret.deliveryInfo.declerations.push(question.name);
					if (question.offer) {
						let newOffer = _.cloneDeep(question.offer);
						delete newOffer.limitBy;
						delete newOffer.organization;
						delete newOffer.active;
						newOffer.count = 1
						prepareBasketExtraOffer(newOffer)
					}
				}
			});
		}

		function prepareBasketExtraOffer(newOffer) {
			let count = newOffer.count || 0;
			let newItem = newOffer.orderedItems[0];

			if (options.inventory[newItem.item]) return;

			for (var i = 0; i < count; i++) {
				let offerId = that.app.getObjectId();
				let itemId = that.app.getObjectId();

				let orderedItem = {
					//"_id": itemId,
					"category": newItem.category && newItem.category._id,
					"item": newItem.item,
					"name": newItem.name,
					"amount": 0,
					"price": 0,
					"tags": [],
					"offer": newItem.offer,
					"menu": newItem.menu,
					"removedModifiers": [],
					"selectedModifiers": []
				}

				let orderedOffer = {
					//"_id": offerId,
					"amount": 0,
					"menu": newOffer.menu,
					"price": 0,
					"offer": newOffer.offer,
					"name": newOffer.realName || newOffer.name,
					"orderedItems": [orderedItem]
				}
				ret.orderedOffers.push(orderedOffer);
			}
		}

		function prepareBasketModifier(mod, group, checkSubMods, checkInventory?) {
			let itemId = (mod.item && mod.item._id) || mod.item;
			if (checkInventory) {
				isInInventory(itemId, mod.name);
			}

			var _mod: any = {
				"modifier": mod._id,
				"name": mod.realName || mod.name,
				"modifierGroup": group._id,
				"modifierGroupName": group.realName || group.name,
				"item": itemId,
				"price": 0,
				"amount": 0,
				"isDefault": mod._isDefault || mod.defaultFormationUnit != null
			};
			if (!isNaN(mod.price) && mod.price !== 0) {
				_mod.price = Math.round(mod.price * 100);
			}
			if (checkSubMods) {
				_mod.formationUnit = mod.formationUnit;
				let selectedModifiers = [], removedModifiers = [];
				_.each(mod.groups, function (group) {
					selectedModifiers.push({
						"modifier": group.value,
						"name": group.valueName,
						"modifierGroup": group._id,
						"modifierGroupName": group.realName || group.name,
						"isDefault": group._default == group.value
					});
				});
				if (mod._item) {
					_.each(mod._item.modifierGroups, function (group) {
						if (group.singleSelection) {
							var mod: any = _.find(group.modifiers, { '_selected': true });
							if (mod) {
								selectedModifiers.push(prepareBasketModifier(mod, group, false, false));
								if (!mod._isDefault) {
									var defMod = _.find(group.modifiers, { '_isDefault': true });
									if (defMod) removedModifiers.push(prepareBasketModifier(defMod, group, false, false));
								}
							}
						}
					});
				}

				if (selectedModifiers.length) {
					_mod.selectedModifiers = selectedModifiers;
				}
				if (removedModifiers.length) {
					_mod.removedModifiers = removedModifiers;
				}
			}
			return _mod;
		}

		function isInInventory(itemId, itemName) {
			let inv = options.inventory[itemId];
			if (inv) {
				if (inv.quantity == 0) {
					wasMissingInInventory = true;
					if (!missingItems[itemId]) {
						missingItems[itemId] = itemName;
					}
					return false;
				}
				inv.quantity = inv.quantity - 1;
			}
			return true;
		}

		function getPreparedOrderPromotion() {
			let that = this;
			let promotion = order.promotion;
			if (!promotion) return;
			let discount = {
				discountType: 'amount',
				value: Math.round(promotion.calc.amount * 100),
				onlinePromoId: promotion._id,
				comment: promotion.name,
				valueType: promotion.valueType,
				reason: promotion.reason,
			};
			ret.orderedDiscounts.push(discount);
		}


	}



}
